import { useState } from 'react'

import { Nullable } from '@types'

import useContactWithProfilesCounts from '@modules/contacts/hooks/useContactWithProfilesCounts'
import { MeetingStatus } from '@modules/contacts/types'
import { AnyProfile, Delegate } from '@modules/search/types'
import { Box } from '@mui/material'
import { useFeatureFlags } from '@shared/hooks/useFeatureFlags'
import { componentSizes } from '@theme/variables'

import ContactsHistoryPopover from '../ContactsHistoryPopover'
import ContactsOverviewCard from '../ContactsOverviewCard'

interface ContactsOverviewCardProps {
  profile: AnyProfile
  isHighlighted?: boolean
}

const ContactsOverviewCardStateFull = (props: ContactsOverviewCardProps) => {
  const { profile, isHighlighted } = props
  const [contactStatusPopupRef, setContactStatusPopupRef] = useState<Nullable<HTMLElement>>(null)
  const companyId = (profile as Delegate).companyId || profile.id

  const handleDetailsClick = (e: Nullable<React.MouseEvent<HTMLElement>>) => {
    setContactStatusPopupRef(e?.target as HTMLElement)
  }

  const countsByCompanyId = useContactWithProfilesCounts({ companyIds: [companyId] })

  const { counts, recentMeeting: rawRecent } = countsByCompanyId[companyId] || {}
  const recentMeeting = rawRecent?.status === MeetingStatus.UPCOMING ? rawRecent : null

  const { hasAccessToContacts } = useFeatureFlags()

  if (!hasAccessToContacts) {
    return null
  }

  return counts || recentMeeting ? (
    <>
      <ContactsOverviewCard
        companyId={companyId}
        counts={counts}
        meeting={recentMeeting}
        onDetailsClick={handleDetailsClick}
        isHighlighted={isHighlighted}
      />

      {contactStatusPopupRef && rawRecent && (
        <ContactsHistoryPopover
          companyId={companyId}
          recentMeeting={rawRecent}
          anchor={contactStatusPopupRef}
          setAnchor={setContactStatusPopupRef}
        />
      )}
    </>
  ) : (
    // Workaround to compensate for the margin from the next section
    // if there is no contacts overview card
    <Box sx={{ marginTop: `-${componentSizes.smDistance}` }} />
  )
}

export default ContactsOverviewCardStateFull
